import {
  FORMULA_LIST_SUCCESS,
  FORMULA_DETAIL_SUCCESS, FETCH_END, FETCH_START
} from '../../../actions/FormulaLab/FormulaLab/ActionTypes';

const initialState = {
  formulaListData: {},
  formulaDetailsData: {},
  loading: false,
  loadingOrg: false,
};

const FormulaLabReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORMULA_LIST_SUCCESS:
      return {
        ...state,
        formulaListData: action.data,
      };
    case FORMULA_DETAIL_SUCCESS:
      return {
        ...state,
        formulaDetailsData: action.data,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;

  }
};

export default FormulaLabReducer;
